import JSZip from 'jszip';
import download from 'downloadjs';

// Original file first, resized versions only as a fallback
export const getAssetDownloadUrl = (asset) => (
  asset?.url?.original || asset?.url?.origin || asset?.url?.large
);

const getAssetFileName = (asset, url) => {
  if (asset.filename) return asset.filename;
  const urlPath = url.split('?')[0];
  return decodeURIComponent(urlPath.substring(urlPath.lastIndexOf('/') + 1));
};

const sanitizeFileName = (name) => name.replace(/[\\/:*?"<>|]/g, '-').trim();

// Cookies are required for signed CDN urls
const fetchAssetBlob = (url) => fetch(url, { credentials: 'include' })
  .then((response) => (response.ok ? response.blob() : Promise.reject(response)));

export const downloadAssetFile = (asset) => {
  const url = getAssetDownloadUrl(asset);
  if (!url) return Promise.reject(new Error('Asset url is missing'));
  return fetchAssetBlob(url)
    .then((blob) => download(blob, getAssetFileName(asset, url), blob.type || asset.media_type));
};

// Browsers block multiple automatic downloads, so all files go into a single zip.
// Resolves with the assets that could not be fetched.
export const downloadAssetsAsZip = (assets, zipName) => {
  const zip = new JSZip();
  const usedNames = new Set();
  const failed = [];

  const addAsset = (asset, index) => {
    const url = getAssetDownloadUrl(asset);
    if (!url) {
      failed.push(asset);
      return Promise.resolve();
    }
    return fetchAssetBlob(url)
      .then((blob) => {
        const fileName = getAssetFileName(asset, url);
        const uniqueName = usedNames.has(fileName) ? `${index + 1}-${fileName}` : fileName;
        usedNames.add(uniqueName);
        zip.file(uniqueName, blob);
      })
      .catch(() => failed.push(asset));
  };

  return assets
    .reduce((chain, asset, index) => chain.then(() => addAsset(asset, index)), Promise.resolve())
    .then(() => {
      if (failed.length === assets.length) return failed;
      return zip.generateAsync({ type: 'blob' })
        .then((blob) => download(blob, sanitizeFileName(zipName), 'application/zip'))
        .then(() => failed);
    });
};
